import { Box, Typography, Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import { forwardRef, memo } from "react";

const EmptyAdminState = forwardRef(
  ({ isAdmin, onCreateShift, onCreateEvent }, ref) => {
    return (
      <Box
        ref={ref}
        sx={{
          mt: 8,
          px: 2,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        {/* ✅ HEADLINE */}
        <Typography variant="h5" sx={{ mt: 1 }}>
          Lass uns starten 👋
        </Typography>

        {/* ✅ MAIN MESSAGE */}
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            maxWidth: 420,
          }}
        >
          Dieser Event ist noch leer. Beginne, indem du einen ersten Event oder
          eine erste Schicht erstellst.
        </Typography>

        {/* ✅ MINI STEPS (guided UX) */}
        <Box sx={{ mt: 1 }}>
          <Typography variant="caption" color="text.secondary">
            1. "Event" erstellen
          </Typography>
          <br />
          <Typography variant="caption" color="text.secondary">
            2. "Schicht" erstellen (min 1)
          </Typography>
          <br />
          <Typography variant="caption" color="text.secondary">
            3. "Jobs" hinzufügen
          </Typography>
          <br />
          <Typography variant="caption" color="text.secondary">
            4. Plätze freigeben
          </Typography>
        </Box>

        {/* ✅ ADMIN ACTION */}
        {isAdmin && (
          <Button
            variant="contained"
            size="large"
            startIcon={<Add />}
            onClick={onCreateEvent}
            sx={{
              mt: 2,
              borderRadius: "30px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
            }}
          >
            Ersten Event erstellen
          </Button>
        )}

        {isAdmin && (
          <Button
            variant="contained"
            size="large"
            startIcon={<Add />}
            onClick={onCreateShift}
            sx={{
              mt: 2,
              borderRadius: "30px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
            }}
          >
            Erste Schicht erstellen
          </Button>
        )}

        {/* ✅ NON-ADMIN MESSAGE */}
        {!isAdmin && (
          <Typography
            variant="body2"
            sx={{
              mt: 2,
              color: "text.secondary",
            }}
          >
            Warte, bis Schichten verfügbar sind.
          </Typography>
        )}
      </Box>
    );
  },
);

export default memo(EmptyAdminState);
